var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('HeaderError'),_c('LeftSidebarError'),_c('div',{staticClass:"flexWrapper"},[_c('main',{staticClass:"error-layout",attrs:{"role":"main"}},[_c('Page')],1),_c('Footer',{staticClass:"error-footer"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }